import React from "react";
import { LocaleUtil } from "@eres/core";
import { SitePlan } from "@my-dld/utils/TabuServices";
import Strings from "@my-dld/assets/strings";
import { AssetCard } from "@10x/dubai-rest-api/dist/property_registry/entity";
import { extractPropInfo } from "../MyDLD/PropertyDetails";
import CheckBoxField from "@my-dld/components/Form/CheckBoxField";
import { saveSitePlan } from "@10x/tabu-mobile-api/dist/requests/api";
import { SitePlanRequest, TabuProcedure } from "@10x/tabu-mobile-api/dist/requests/entity";
import { TabuUtils } from "@10x/tabu-mobile-api";
import { hideLoading, showErrorMessage, showLoading } from "@my-dld/utils/UIUtils";
import { getParticipantID } from "@10x/sso";
import BaseTabuRequestForm, { addAgentParticipantId, BaseTabuRequestProps } from "./BaseTabuRequestForm";
import { DashboardBCItem } from "@my-dld/contexts/PageContext";
import PageTitle from "@my-dld/components/PageTitle";
import { Redirect } from "react-router";
import PageContent from "@my-dld/components/PageContent";
import { trackEventWithData } from "@my-dld/utils/Analytics";
import { TabuRequestContext } from "@my-dld/contexts/TabuRequestContext";

interface State {
	withSurvey: boolean;
	property?: AssetCard;
}

class SiteplanForm extends BaseTabuRequestForm<BaseTabuRequestProps, State> {
	static contextType = TabuRequestContext;
	context!: React.ContextType<typeof TabuRequestContext>;

	constructor( props: BaseTabuRequestProps ) {
		super( props );
		this.state = {
			withSurvey: false,
		};
	}

	componentDidMount() {
		this.setState( {
			property: this.context.property,
		} );
	}

	render() {
		const property = this.context.property;
		if ( property == null ) {
			return <Redirect to={ "/mydld" }/>;
		}
		const title = LocaleUtil.getLocalValue( SitePlan.Name );
		const { val, lbl } = extractPropInfo( property );
		return <PageContent
			title={ `${ title } - ${ lbl } : ${ val }` }
			hideQLinks={ true }>
			<PageTitle title={ title } paths={ [ DashboardBCItem ] }/>
			<div className="section-title">
				<h5>{ title }</h5>
			</div>
			<div className="mb-3">
				<small>{ Strings.mandatory_fields_note }</small>
			</div>
			<CheckBoxField
				id={ "withSurvey" }
				holder={ this }
				label={ Strings.with_survey }
				/>
			<div className="form-group mt-3">
				<button
					className="btn btn_1 btn_style1" type="submit" id="btnContinue"
					onClick={ this.submitSiteplanRequest }>{ Strings.continue }</button>
				<a className="ms-3" onClick={ this.props.history.goBack }>{ Strings.cancel }</a>
			</div>
		</PageContent>;
	}

	private submitSiteplanRequest = () => {
		showLoading();
		const req: SitePlanRequest = {
			ParticipantId: "" + getParticipantID(),
			ProcedureId: SitePlan.ID,
			WithSurvey: this.state.withSurvey ? 1 : 0,
			PropertyWithTypeIds: [ {
				PropertyId: this.state.property!.tabuPropertyId,
				PropertyTypeId: this.state.property!.propertyTypeId
			} ],
			Identity: 0,
		};
		addAgentParticipantId( this.state.property, req );
		trackEventWithData( "TabuProcedure", "TrySubmit", req );
		saveSitePlan( req ).then( TabuUtils.validateResponse ).then( ( resp: TabuProcedure ) => {
			hideLoading();
			trackEventWithData( "TabuProcedure", "SubmitSuccess", {
				number: resp.ProcedureNumber,
				year: resp.ProcedureYear, ...req
			} );
			this.navigateToVoucher( this.props, resp );
		} ).catch( ( reason ) => {
			hideLoading();
			showErrorMessage( reason.toString() );
			trackEventWithData( "TabuProcedure", "SubmitFail", { reason: reason.toString(), ...req } );
		} );
	};
}

export default SiteplanForm;
